export const managers = [
  {
    id: "m1",
    type: "manager",
    name: "Empire West Property Management",
    address: "4605 Lankershim Blvd #824, North Hollywood, CA 91602",
    phone: "(818) 982-1220",
    photo: null,
    initials: "EW",
    rating: 3.4,
    reviewCount: 51,
    neighborhood: "North Hollywood",
    about: "Property management company serving the North Hollywood area since 2005.",
    reviews: [
      { id: "r1", author: "Sarah M.", rating: 2, date: "March 2025", text: "Maintenance requests take forever. Had to follow up 4 times to get my AC fixed." },
      { id: "r2", author: "James T.", rating: 4, date: "Jan 2025", text: "New management team is much better. Responsive and professional." },
      { id: "r3", author: "Maria L.", rating: 3, date: "Nov 2024", text: "Average experience. Nothing great, nothing terrible. Communication could improve." },
    ]
  },
  {
    id: "m2",
    type: "manager",
    name: "I & R Management",
    address: "5249 Bakman Ave, North Hollywood, CA 91601",
    phone: "(818) 985-3400",
    photo: null,
    initials: "IR",
    rating: 3.8,
    reviewCount: 11,
    neighborhood: "North Hollywood",
    about: "Boutique property management serving North Hollywood residential properties.",
    reviews: [
      { id: "r4", author: "David K.", rating: 5, date: "Feb 2025", text: "Great communication and always there when needed. Best management I have had." },
      { id: "r5", author: "Lisa R.", rating: 2, date: "Dec 2024", text: "Water shutoffs with no warning. Very disruptive to daily life." },
    ]
  },
  {
    id: "m3",
    type: "manager",
    name: "P.A.C. Properties",
    address: "12716 Riverside Dr, Valley Village, CA 91607",
    phone: "(818) 766-7727",
    photo: null,
    initials: "PA",
    rating: 4.4,
    reviewCount: 341,
    neighborhood: "Valley Village",
    about: "One of the San Fernando Valley's most trusted property management groups.",
    reviews: [
      { id: "r6", author: "Tom B.", rating: 5, date: "March 2025", text: "Love how easy everything is. Pay rent online, submit requests online. Fast response every time." },
      { id: "r7", author: "Anna C.", rating: 4, date: "Feb 2025", text: "Really solid management. Maintenance is always handled quickly and properly." },
    ]
  },
  {
    id: "m4",
    type: "manager",
    name: "SKY Properties",
    address: "10153 Riverside Dr #430, Toluca Lake, CA 91602",
    phone: "(323) 882-6606",
    photo: null,
    initials: "SK",
    rating: 4.1,
    reviewCount: 145,
    neighborhood: "Toluca Lake",
    about: "Full-service property management with a focus on resident satisfaction.",
    reviews: [
      { id: "r8", author: "Kevin W.", rating: 5, date: "Jan 2025", text: "Night and day difference since SKY took over. Things actually get fixed now." },
      { id: "r9", author: "Rachel S.", rating: 3, date: "Nov 2024", text: "Decent management. Some delays on maintenance but always resolved eventually." },
    ]
  },
];

export const tenants = [
  {
    id: "t1",
    type: "tenant",
    name: "Michael Rodriguez",
    initials: "MR",
    rentalHistory: [
      { address: "1234 Lankershim Blvd #5, North Hollywood", dates: "Jan 2022 – Dec 2024", manager: "Empire West Property Management" },
      { address: "567 Camarillo St #2, North Hollywood", dates: "Mar 2019 – Dec 2021", manager: "I & R Management" },
    ],
    reviews: [
      { id: "rt1", author: "Empire West PM", rating: 4, date: "Jan 2025", text: "Reliable tenant. Always paid on time. Left the unit in good condition." },
      { id: "rt2", author: "I & R Management", rating: 5, date: "Jan 2022", text: "Excellent tenant. Would rent to again without hesitation." },
    ]
  },
  {
    id: "t2",
    type: "tenant",
    name: "Jennifer Park",
    initials: "JP",
    rentalHistory: [
      { address: "890 Vineland Ave #12, North Hollywood", dates: "Jun 2023 – Present", manager: "P.A.C. Properties" },
    ],
    reviews: [
      { id: "rt3", author: "P.A.C. Properties", rating: 3, date: "Aug 2024", text: "Good tenant overall. Occasional late payments but always communicated in advance." },
    ]
  },
];

export const allProfiles = [...managers, ...tenants];
